/**
 * AddCartButton，加购按钮，点击元素本身触发
 *
 * Attributes:
 * @param {String} data-variant-id 产品变体 ID
 * @param {String} data-quantity 购买数量，可选，默认为1
 *
 * @example
 * ```html
 * <add-cart-button role="button" data-variant-id="{{ product.first_available_variant.id }}" data-quantity="1" class="button round">
 *   Add to cart
 *   {%- render 'loading-spinner' -%}
 * </add-cart-button>
 * ```
 */
if (!customElements.get("add-cart-button")) {
  class AddCartButton extends HTMLElement {
    // 标记
    _marks = {
      loading: "loading",
    };

    headers = {
      Accept: "application/json",
      'X-Requested-With': 'XMLHttpRequest',
      "Content-Type": "application/json",
    };

    get _variantId() {
      return this.getAttribute("data-variant-id");
    }
    get _quantity() {
      return this.getAttribute("data-quantity") ?? 1;
    }

    constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    connectedCallback() {
      this.elements = {
        loadingSpinner: this.querySelector(".loading__spinner"),
      };
      this.addEventListener("click", (e) => {
        if (this.hasAttribute("disabled")) {
          return;
        }
        this.startLoading();
        this.addToCart().finally(() => {
          this.finishLoading();
        });
      });
    }

    /**
     * 更新购物车，并弹出侧边购物车
     * @returns 
     */
    async updateCart(response) {
      const cartDrawer = document.querySelector("cart-drawer");
      // 移除空状态
      cartDrawer.classList.remove("is-empty");
      const emptyContent = cartDrawer.querySelector(".drawer__inner-empty");
      if (emptyContent) {
        cartDrawer.querySelector(".drawer__inner-empty").outerHTML = '';
      }
      // 通知全局
      publish(PUB_SUB_EVENTS.cartUpdate, {
        cartData: response,
      });
      // 如果在购物车页面，需要刷新购物车
      const mainCartItems = document.querySelector('#main-cart cart-items');
      if (mainCartItems) {
        await mainCartItems.reload();
      }
      cartDrawer.renderContents(response);
      cartDrawer.open();
    }

    /**
     * 加购
     */
    async addToCart() {
      const variantIds = this._variantId.split(",");

      const items = variantIds.map((id) => {
        return {
          form_type: "product",
          utf8: "✓",
          id: parseInt(id, 10),
          quantity: this._quantity,
        };
      });

      let data_json = {
        items: items,
      };

      if (this.cart) {
        data_json['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
        data_json['sections_url'] = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      let data = JSON.stringify(data_json);
      return fetch(routes.cart_add_url ?? "/cart/add.json", {
        method: "POST",
        headers: this.headers,
        body: data,
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            if (response.status === 422) {
              alert("Inventory shortage!");
            }
            throw new Error("请求失败");
          }
        }).then((response) => {
          return this.updateCart(response);
        })
        .catch((err) => {
          console.error(err);
        });
    }

    startLoading() {
      this.setAttribute("aria-disabled", true);
      this.classList.add(this._marks.loading);
      this.elements.loadingSpinner?.classList.remove("hidden");
    }

    finishLoading() {
      this.removeAttribute("aria-disabled");
      this.classList.remove(this._marks.loading);
      this.elements.loadingSpinner?.classList.add("hidden");
    }
  }

  customElements.define("add-cart-button", AddCartButton);
}
